import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { LoadingController } from '@ionic/angular';
import { AuctionService } from 'src/app/data/service/auction.service';
import { AppSettings } from '../configs/app.settings';
import { Utilities } from '../helper/util';

@Injectable()
export class AuctionGuard implements CanActivate {

    constructor(private auctionService: AuctionService, private router: Router, private loadCtrl: LoadingController) { }

    async canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {

        const code = next.paramMap.get('code');

        if (this.auctionService.inAuction == true && this.auctionService.currentAuction.accessCode === code) {
            // console.log('Already in auction', code);
            if (next.data.accessLevel != null) {
                return this.testAccess(next.data.accessLevel);
            }
            return true;
        }


        if (Utilities.stringEmpty(code)) {
            // console.log('No Code');
            this.router.navigateByUrl('/home');
            return false;
        }

        // console.log('Loading auction', code);
        const loading = await this.loadCtrl.create({
            message: 'Loading auction...',
            spinner: 'crescent',
            translucent: true
        });

        try {
            loading.present();
            await this.auctionService.getAuctionByCode(code, true);
            if (this.auctionService.inAuction) {
                // If an access level was passed in data, read it and validate
                if (next.data.accessLevel == null) {
                    return true;
                }
                const hasAccess = this.testAccess(next.data.accessLevel);
                if (hasAccess == false) {
                    this.router.navigateByUrl(`/auction/${code}/browse`);
                }
                return hasAccess;
            }
            this.router.navigateByUrl('/home');
            return false;
        } catch (error) {
            // console.log('Attempt to load auction with code error', error);
            this.router.navigateByUrl('/home');
            return false;
        } finally {
            loading.dismiss();
        }
    }

    private testAccess(accessLevel: string) {
        // console.log('Page requires access level', accessLevel);
        switch (accessLevel) {
            case 'Admin':
                // For admin we can't allow access if it's not a web app
                // console.log(this.auctionService.isAuctionAdmin);
                return this.auctionService.isAuctionAdmin && AppSettings.isWebApp;
        }
        return true;
    }
}
